import axios from 'axios';


// 요청 인터셉터 추가하기  -> 서버에 요청하기전 인터셉터
axios.interceptors.request.use(
    (config) => {
        //console.log("=================request ==============================");
        // 파라미터에 사용자 Timezone 셋팅하여 전송
        config.params = { 
            ...config.params, 
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        //console.log(config.params);
        //console.log("요청 url", config.url)

        //console.log("=================request ==============================");
        // 파라미터에 사용자 Timezone 셋팅하여 전송
        config.params = {
            ...config.params,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };


        let browserLang = (navigator.language || navigator.userLanguage || navigator.systemLanguage).toLowerCase();

        //브라우저 언어가 영어 설정이 아닐때 강제로 언어를 영문으로 요청(추후 언어가 추가되면 수정필요)
        if (!browserLang.includes('en')) {
        //if (!browserLang.includes('en') && !browserLang.includes('ko')) {
            config.headers['Accept-Language'] = 'en-US';
        }

        return config;
    },
    (error) => {
        console.log("=================reuest error =======================")
        return Promise.reject("request error :", error);
    }
);

export default axios;